import {
  ReceivedInvoiceAutomaticStatus,
  UploadType,
} from '@/context/services/invoice/type';
import { getReceivedInvoiceReadTagKind } from '@/features/invoices/utils/getReceivedInvoiceReadTagKind';
import { useRenewalUiReceivedInvoicesFlag } from '@/hooks/feature_flag/useRenewalUiReceivedInvoicesFlag';
import { useGetFlags } from '@/hooks/useFeatureFlag';
import { useTranslation } from '@/i18n';
import { Tag } from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';

export type ReceivedInvoiceReadTagProps = {
  uploadType?: UploadType;
  automaticStatus?: ReceivedInvoiceAutomaticStatus;
};

export const ReceivedInvoiceReadTag: FC<ReceivedInvoiceReadTagProps> = memo(
  ({ uploadType, automaticStatus }) => {
    const { t } = useTranslation();
    const enhanceSearch = useGetFlags('ENHANCE_INVOICE_LIST_SEARCH');
    const isRenewalUiReceivedInvoices = useRenewalUiReceivedInvoicesFlag();

    const kind = getReceivedInvoiceReadTagKind({
      enhanceSearch,
      uploadType,
      automaticStatus,
    });

    if (!kind) {
      return null;
    }

    let label: string;
    if (kind === 'operator') {
      label = t('invoice_operator_read_tag');
    } else if (isRenewalUiReceivedInvoices) {
      label = t('invoice_ocr_read_tag_renewal_ui');
    } else {
      label = t('invoice_ocr_read_tag');
    }

    return (
      <Tag closable={false} outline={false} icon={false}>
        {label}
      </Tag>
    );
  }
);
ReceivedInvoiceReadTag.displayName = 'ReceivedInvoiceReadTag';
